"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPartnerHostedLivestreamPostStreamExclusiveTimespanPropertyOption = exports.isPartnerHostedLivestreamPostStreamExclusiveTimespanProperty = exports.partnerHostedLivestreamPostStreamExclusiveTimespanPropertyDefinition = void 0;
const partnerHostedLivestreamPostStreamExclusiveTimespanPropertyOptions = [
    'PT0H',
    'PT1H',
    'PT2H',
    'PT3H',
    'PT4H',
    'PT5H',
    'PT6H',
    'PT7H',
    'PT8H',
    'PT9H',
    'PT10H',
    'PT11H',
    'PT12H',
    'PT13H',
    'PT14H',
    'PT15H',
    'PT16H',
    'PT17H',
    'PT18H',
    'PT19H',
    'PT20H',
    'PT21H',
    'PT22H',
    'PT23H',
    'PT24H',
];
exports.partnerHostedLivestreamPostStreamExclusiveTimespanPropertyDefinition = {
    view: { label: 'Post-stream time geoblocked' },
    constraints: [
        {
            name: 'options',
            argument: partnerHostedLivestreamPostStreamExclusiveTimespanPropertyOptions,
        },
    ],
    type: 'duration',
    multiple: false,
    name: 'partner-hosted-livestream-post-stream-exclusive-timespan',
};
const isPartnerHostedLivestreamPostStreamExclusiveTimespanProperty = (prop) => {
    return prop.name === exports.partnerHostedLivestreamPostStreamExclusiveTimespanPropertyDefinition.name;
};
exports.isPartnerHostedLivestreamPostStreamExclusiveTimespanProperty = isPartnerHostedLivestreamPostStreamExclusiveTimespanProperty;
const isPartnerHostedLivestreamPostStreamExclusiveTimespanPropertyOption = (option) => {
    return partnerHostedLivestreamPostStreamExclusiveTimespanPropertyOptions.includes(option);
};
exports.isPartnerHostedLivestreamPostStreamExclusiveTimespanPropertyOption = isPartnerHostedLivestreamPostStreamExclusiveTimespanPropertyOption;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFydG5lci1ob3N0ZWQtbGl2ZXN0cmVhbS1wb3N0LXN0cmVhbS1leGNsdXNpdmUtdGltZXNwYW4ucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9wYXJ0bmVyLWhvc3RlZC1saXZlc3RyZWFtLXBvc3Qtc3RyZWFtLWV4Y2x1c2l2ZS10aW1lc3Bhbi5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSxNQUFNLGlFQUFpRSxHQUFHO0lBQ3hFLE1BQU07SUFDTixNQUFNO0lBQ04sTUFBTTtJQUNOLE1BQU07SUFDTixNQUFNO0lBQ04sTUFBTTtJQUNOLE1BQU07SUFDTixNQUFNO0lBQ04sTUFBTTtJQUNOLE1BQU07SUFDTixPQUFPO0lBQ1AsT0FBTztJQUNQLE9BQU87SUFDUCxPQUFPO0lBQ1AsT0FBTztJQUNQLE9BQU87SUFDUCxPQUFPO0lBQ1AsT0FBTztJQUNQLE9BQU87SUFDUCxPQUFPO0lBQ1AsT0FBTztJQUNQLE9BQU87SUFDUCxPQUFPO0lBQ1AsT0FBTztJQUNQLE9BQU87Q0FDQyxDQUFBO0FBRUcsUUFBQSxvRUFBb0UsR0FBRztJQUNsRixJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsNkJBQTZCLEVBQUU7SUFDOUMsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsU0FBUztZQUNmLFFBQVEsRUFBRSxpRUFBaUU7U0FDNUU7S0FDRjtJQUNELElBQUksRUFBRSxVQUFVO0lBQ2hCLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLDBEQUEwRDtDQUNqQyxDQUFBO0FBSTFCLE1BQU0sNERBQTRELEdBQ3hFLENBQUMsSUFBa0IsRUFBc0UsRUFBRTtJQUN6RixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssNEVBQW9FLENBQUMsSUFBSSxDQUFBO0FBQ2hHLENBQUMsQ0FBQTtBQUhXLFFBQUEsNERBQTRELGdFQUd2RTtBQUlLLE1BQU0sa0VBQWtFLEdBQzdFLENBQUMsTUFBYyxFQUE4RSxFQUFFO0lBQzdGLE9BQVEsaUVBQXVGLENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQyxDQUFBO0FBQ2xILENBQUMsQ0FBQTtBQUhVLFFBQUEsa0VBQWtFLHNFQUc1RSJ9